const IMAGE_SETTINGS = {
    small: {
        '1920w': {
            width: 480,
            height: 278,
        },
    },
    medium: {
        '1920w': {
            width: 720,
            height: 417,
        },
    },
    large: {
        '1920w': {
            width: 960,
            height: 556,
        },
        '1280w': {
            width: 640,
            height: 377,
        },
    },
    extralarge: {
        '1920w': {
            width: 1920,
            height: 900,
        },
        '1280w': {
            width: 1280,
            height: 800,
        },
        '800w': {
            width: 800,
            height: 600,
        },
    },
};

export default IMAGE_SETTINGS;
